<div class="return-link-row">
  &lt;
  <span class="return-link" (click)="navigateToList()">Companies</span>
</div>

<ng-template #licenseBatchesTemplate let-member>
  <span class="license-batches-cell">
    <ng-container
      *ngFor="
        let batch of getLicenseBatches(member);
        let last = last;
        trackBy: trackLicenseBatch
      "
    >
      <a
        *ngIf="canNavigateLicenseBatches"
        [routerLink]="getLicenseBatchRoute(batch)"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="'Open license batch ' + getLicenseBatchLabel(batch)"
        >{{ getLicenseBatchLabel(batch) }}</a
      ><span *ngIf="!canNavigateLicenseBatches">{{
        getLicenseBatchLabel(batch)
      }}</span
      ><span *ngIf="!last">, </span>
    </ng-container>
    <span *ngIf="getLicenseBatches(member).length === 0">—</span>
  </span>
</ng-template>

<app-header
  data-testid="company-header"
  [title]="company()?.name || 'Company Details'"
  [subtitle]="company()?.industry || ''"
>
  <app-button
    *ngIf="canManageCompany"
    [black]="true"
    [title]="'Edit Company'"
    (click)="navigateToEdit()"
    header-button
  ></app-button>
</app-header>

<app-response-banner
  [success]="successfulSave()"
  [successMessage]="successMessage()"
  [errorMessage]="errorMessage()"
  [invisible]="!showResponseBanner()"
></app-response-banner>

<div class="status-card" *ngIf="isLoading()">Loading company details...</div>

<div class="status-card error" *ngIf="!isLoading() && error()">
  {{ error() }}
</div>

<div
  class="content"
  data-testid="company-details"
  *ngIf="!isLoading() && !error()"
>
  <ng-container *ngIf="company() as selectedCompany">
    <section class="company-section">
      <div class="table-header">
        <h1>General Information</h1>
        <div class="line-part"></div>
      </div>

      <div class="company-layout">
        <div class="company-column">
          <div class="info-grid">
            <div class="label">Company Name</div>
            <div class="value">{{ selectedCompany.name || '-' }}</div>

            <div class="label">Company ID</div>
            <div class="value">{{ selectedCompany.id || '-' }}</div>

            <div class="label">Country</div>
            <div class="value">{{ selectedCompany.country || '-' }}</div>

            <div class="label">State or Province</div>
            <div class="value">
              {{ selectedCompany.stateOrProvince || '-' }}
            </div>

            <div class="label">Postal Code</div>
            <div class="value">{{ selectedCompany.postalCode || '-' }}</div>

            <div class="label">Industry</div>
            <div class="value">{{ selectedCompany.industry || '-' }}</div>
          </div>

          <div class="description">
            {{
              selectedCompany.fieldsOfApplication?.length
                ? selectedCompany.fieldsOfApplication?.join(', ')
                : 'No fields of application provided.'
            }}
          </div>
        </div>

        <div class="company-column image-column">
          <img
            src="../../../assets/imgs/placeholder-avatar.png"
            alt="Company placeholder"
          />
        </div>
      </div>
    </section>

    <section class="members-section">
      <div class="table-header">
        <h1>Members</h1>
        <div class="line-part"></div>
      </div>

      <div class="members-toolbar">
        <app-button
          *ngIf="canManageCompany"
          [black]="true"
          [title]="'+ Invite Member'"
          testId="company-invite-open"
          (click)="openInviteDialog()"
        ></app-button>
        <div class="member-meta">
          {{ sortedMembers().length }} member{{
            sortedMembers().length === 1 ? '' : 's'
          }}
        </div>
      </div>

      <div class="status-card" *ngIf="savingMemberAction()">
        Saving member changes...
      </div>

      <div class="members-table-wrapper">
        <qs-table
          testId="company-members"
          [rowTestIdFn]="memberRowTestId"
          [data]="sortedMembers()"
          [columns]="visibleMemberColumns"
          [isSearchEnabled]="true"
          [isPaginatorEnabled]="true"
          [paginatorConfig]="tablePaginatorConfig"
        >
        </qs-table>
      </div>
    </section>
  </ng-container>
</div>
